import { LeMagFeaturedArticle, ProfileType } from "../../model";
import { leMagService } from "../LeMagService";

export declare interface FeaturedResponse {
  infos: {
    total_items: number;
  };
  articles: LeMagFeaturedArticle[];
}

export const getFeaturedArticles = (
  page = 1,
  limit = 10,
  profileType = ProfileType.GENERIC,
) => {
  let age = "";
  switch (profileType) {
    case ProfileType.KIDS:
      age = "3";
      break;
    case ProfileType.PRE_TEENS:
      age = "7";
      break;
    case ProfileType.TEENS:
      age = "12";
      break;
    default:
      age = "18";
  }

  return leMagService.get<FeaturedResponse>({
    path: `${age}/featured-inapp`,
    params: {
      page,
      items: limit,
    },
  });
};
